// We want to add a className if the element has a hover, to use it in styling.
// Use an abbreviated className to save up DOM space.
const TRUE = 'hh'

export const getHover = ({localRef, colorSet, disabled, onClick, hasHover, to, externalLink}) => {
	if (colorSet === 'disabled' || disabled) return false

	if (!!onClick || !!hasHover || !!to || !!externalLink) return TRUE

	// We check if the parent has a hover, in that case the hh class is passed down to its child layout
	// This is in the case where the child has the colorSet logic, but the parent handles the hover or click logic.
	const parentClickClassNames = [TRUE, 'link']
	const parentHasHover = parentClickClassNames.some(c => localRef?.current?.parentNode?.className.includes(c))
	if (parentHasHover) return TRUE

	return false
}
